import * as React from "react";
import {useTranslation} from "react-i18next";
import styles from "./AdvantagesBanner.module.scss";
import {getShopId} from "../getShopId";

/* --Desktop List-Version-- */
const AdvantagesBannerDesktop: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.listWrapper}>
      <ul>
        <li>
          <span className="icon icon-check--lightgreen" />
          {t("general.30DaysReturnPolicy")}
          {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
        </li>
        <li>
          <span className="icon icon-check--lightgreen" />
          {t("general.freeReturnsForParcelGoods")}
          {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
        </li>
        <li>
          <span className="icon icon-check--lightgreen" />
          {t("general.24000products--cnt", {cnt: Intl.NumberFormat([]).format(24000)})}
        </li>
      </ul>
    </div>
  );
};

export default AdvantagesBannerDesktop;
